import { CommunityStore } from 'types';
import { initState } from './initState';
import { actions } from './actions';
import { thunks } from './thunks';

export const community: CommunityStore = {
  ...initState,
  ...actions,
  ...thunks,
};
